import { timelineBars, sessionBarsToNative } from '@/audio/clipTiming';
import { buildClassSession, buildMyBeat, CLASS_GROUPS } from './classSession';
import { seatPackFingerprint } from './seatPacks';
import { rotateExpoPack } from './expoPackRotation';
export { expoVarietyNotice } from './expoPackRotation';

// Four-bar phrases closest to 52 seconds, always between 45 and 60 seconds.
export function expoBars(bpm) {
  let choices = Array.from({ length: 64 }, (_, i) => (i + 1) * 4)
    .filter((bars) => bars * 240 / bpm >= 45 && bars * 240 / bpm <= 60);
  if (!choices.length) choices = Array.from({ length: 256 }, (_, i) => i + 1).filter((bars) => bars * 240 / bpm >= 45 && bars * 240 / bpm <= 60);
  return choices.sort((a, b) => Math.abs(a * 240 / bpm - 52) - Math.abs(b * 240 / bpm - 52))[0] || 16;
}
export function expoCatalog(packs) {
  return Object.fromEntries(CLASS_GROUPS.map((g) => [g, [...new Map(packs.flatMap((p) => p.slots[g]).map((loop) => [loop.id, loop])).values()]]));
}
export function freshExpoPack(packs, previous = [], options = {}) {
  return rotateExpoPack(packs, previous, options);
}
export function expoSession(pack) {
  const built = buildClassSession(pack);
  return { ...built, totalBars: expoBars(pack.bpm), classSession: { ...built.classSession, flow: 'expo', expoBars: expoBars(pack.bpm) } };
}
export function buildExpoBeat(arrangement, bpm) {
  const next = buildMyBeat(arrangement);
  const length = expoBars(bpm);
  const endStart = length - 4;
  return { ...next, sectionMarkers: [
    { id: 'expo-intro', name: 'Intro', startBar: 0 },
    { id: 'expo-hook', name: 'Hook', startBar: 4 },
    { id: 'expo-outro', name: 'Outro', startBar: endStart },
  ], tracks: next.tracks.map((track) => {
    if (track.inBank || track.muted) return track;
    const source = track.clips[0];
    const start = track.instrument === 'drums' ? 4 : 0;
    const sustainsOutro = next.tracks.some((item) => !item.inBank && !item.muted && !['texture', 'fx'].includes(item.instrument));
    const keepOutro = sustainsOutro || track.id !== next.tracks.find((item) => !item.inBank && !item.muted)?.id;
    const end = keepOutro && (track.instrument === 'texture' || track.instrument === 'fx') ? endStart : length;
    const clips = [];
    const width = timelineBars(source, bpm);
    for (let bar = start; bar < end - 1e-6; bar += width) {
      clips.push({ ...source, id: `${source.id}-expo-${bar}`, start_bar: bar, bars: sessionBarsToNative(Math.min(width, end - bar), source, bpm), offset: 0 });
    }
    return { ...track, clips };
  }) };
}
export { seatPackFingerprint };
